import { useMemo } from 'react';

import { useSelector } from 'src/hooks/useSelector';
import { ResumesViewSettingFields } from 'src/models/resumesViewSettings';

export const useResumeSettingsViewFields = (): Array<{ name: ResumesViewSettingFields; active: boolean }> => {
    const viewFields = useSelector((state) => state.resumesViewSettings?.viewFields || []);
    return useMemo(() => viewFields.filter((field) => field.name !== ResumesViewSettingFields.Profarea), [viewFields]);
};
